module.exports = __webpack_public_path__ + "static/media/Sprchovy_gel_s_CBD_retina.06412742.jpg";